import React from 'react'

const Voorwaarden = () => {

    return (
        <div id="Container">
            <h1>Algemene voorwaarden</h1>
            <p>
                Welkom bij MKS-Dashboard!<br /><br />

                Deze algemene voorwaarden omschrijven de regels en voorschriften voor het gebruik van de website van MKS-Dashboard en/of ander aanverwante services die MKS-Dashboard aanbied,
                gelegen op/gekoppeld aan https://mks-dashboard.github.io.<br /><br />

                Door deze website te bezoeken, gaan we ervan uit dat je deze algemene voorwaarden accepteert.
                Blijf MKS-Dashboard niet gebruiken als je niet akkoord gaat met alle voorwaarden die op deze pagina worden vermeld.<br />
            </p>

            <h2>Leeftijd:</h2>
            <p>
                Ieder die gebruik maakt van MKS-Dashboard heeft een minimale leeftijd van 16jaar of ouder.
                Wanneer gebruiker onder de 16 jaar is dient hij/zij uitdrukkelijke toestemming van ouders en/of wettelijke vertegenwoordigers.
            </p>

            <h2>Externe gegevens:</h2>
            <p>
                De website maakt gebruik van externe om je online ervaring persoonlijker te maken.
                Door MKS-Dashboard te openen, stemde je ermee in om de vereiste gegevens te gebruiken.<br />

                De gegevens laad je in door middel van het invoeren van je sessionID van meldkamerspel.com. (welke op geen enkele manier is betrokken bij de ontwikkeling van deze applicatie)
                Omdat de gegevens via een ander systeem worden ingeladen maak je ook gebruik van onze eigen services welke eveneens vallen onder deze voorwaarden.
                <br />

            </p>

            <h2>Licentie:</h2>
            <p>
                Tenzij anders vermeld, bezit MKS-Dashboard en/of zijn licentiegevers de intellectuele eigendomsrechten voor alle gegevens op MKS-Dashboard.
                Alle intellectuele eigendomsrechten zijn voorbehouden.
                Je hebt hier toegang toe vanaf MKS-Dashboard voor je eigen persoonlijk gebruik,
                onderworpen aan de beperkingen die in deze algemene voorwaarden zijn vastgelegd.<br />
                <br />
                Je mag geen:
                <ul>
                    <li>Materiaal van MKS-Dashboard kopiëren of opnieuw publiceren</li>
                    <li>Materiaal van MKS-Dashboard verkopen, verhuren of in sublicentie geven</li>
                    <li>Materiaal van MKS-Dashboard reproduceren, dupliceren of kopieren</li>
                    <li>Herdistribueren van inhoud van MKS-Dashboard</li>
                </ul>
                Deze overeenkomst begint op deze datum.<br />
                <br />
                Delen van de website bedien de mogelijkheid om eigen gegevens te versturen, om bepaalde gegevens mee te krijgen.
                MKS-Dashboard zal deze ingevulde gegevens gebruiken voor het kunnen aanbieden van de juiste informatie.
                Wanneer data wordt verzameld houd MKS-Dashboard het recht om deze voor statistische doeleinde op te slaan.
                Gebruikers hebben het recht om deze gegevens op te vragen via de mail van de applicatie.
                MKS-Dashboard is niet aansprakelijk voor eventuele onvolledige of incorrecte data.
                Ook heeft de gebruiker volledige aansprakelijkheid voor de door hem/haar aangeleverde data.
                <br /><br />
                MKS-Dashboard houd het recht om de ingevoerde en verkregen gegevens te controleren en verwerken.
                Bij een constatering op inbreuk op de voorwaarden heeft MKS-Dashboard eveneens het recht
                om zonder schriftelijke vermelding een gebruiker uit te sluiten van de geboden service.
                <br /><br />
            </p>

            <h2>Aansprakelijkheid voor inhoud:</h2>
            <p>
                Wij kunnen niet verantwoordelijk worden gehouden voor enige inhoud die op je website verschijnt.
                Je stemt ermee in om ons te beschermen en te verdedigen tegen alle claims die op je website worden ingediend.
                Er mogen geen link(s) op een website verschijnen die kunnen worden geïnterpreteerd als lasterlijk, obsceen of crimineel, of die inbreuk maken, anderszins schendt of pleit voor de inbreuk of andere schending van rechten van derden.
            </p>

            <h2>Voorbehoud van rechten:</h2>
            <p>
                MKS-Dashboard behoud zich het recht om alle gebruikersgegevens te bewaren voor statistische en ondersteuningsdoeleinden.
                Verder kan MKS-Dashboard op ieder gewenst moment externe partijen vragen om gegevens over de applicatie offline te halen en verwijderen.
                Door naar MKS-Dashboard door te linken gaan U en uw gebruikers automatisch akkoort met de voorwaarden.
                Verder behoud MKS-Dashboard het recht de voorwaarde op ieder moment aan te kunnen passen. Bij grote ingrijpende veranderingen kunnen hierin notificaties worden geplaatst.
            </p>

            <h2>Disclaimer</h2>
            <p>
                Voor zover maximaal toegestaan ​​door de toepasselijke wetgeving, sluiten we alle verklaringen, garanties en voorwaarden met betrekking tot onze website en het gebruik van deze website uit.
                Niets in deze disclaimer zal:
                <ul>
                    <li>onze of jouw aansprakelijkheid voor overlijden of persoonlijk letsel beperken of uitsluiten;</li>
                    <li>beperking of uitsluiting van onze of jouw aansprakelijkheid voor fraude of frauduleuze verkeerde voorstelling van zaken;</li>
                    <li>een van onze of jouw aansprakelijkheden beperken op een manier die niet is toegestaan ​​onder de toepasselijke wetgeving; of</li>
                    <li>sluit een van onze of jouw aansprakelijkheden uit die mogelijk niet worden uitgesloten onder de toepasselijke wetgeving.</li>
                </ul>

                De beperkingen en verbodsbepalingen van aansprakelijkheid uiteengezet in deze Sectie en elders in deze disclaimer:
                (a) zijn onderworpen aan de voorgaande paragraaf; en (b) alle aansprakelijkheden regelen die voortvloeien uit de disclaimer,
                inclusief aansprakelijkheden die voortvloeien uit een contract, onrechtmatige daad en voor schending van wettelijke plichten.<br />
                <br />
                Zolang de website en de informatie en diensten op de website gratis worden aangeboden,
                zijn wij niet aansprakelijk voor verlies of schade van welke aard dan ook.<br />
            </p>

        </div >
    )
}

export default Voorwaarden
